// extracted by mini-css-extract-plugin
module.exports = {"list":"PagesListBox_list__2tRef","active":"PagesListBox_active__12_11"};